import { sleepStagesUpdate } from "./sleepStagesUpdate";
import { SleepStagesChartData } from "./types";

import { HoverTooltip } from "../shared/components/HoverTooltip";
import { SideBar } from "../shared/components/SideBar";
import { Tags } from "../shared/components/Tags";
import { XAxisGroup } from "../shared/components/XAxisGroup";
import { YAxisGroup } from "../shared/components/YAxisGroup";
import { ResponsiveSVG } from "../shared/ResponsiveSVG";

type SleepStagesChartProps = {
  data: SleepStagesChartData;
};

export const SleepStagesChart = ({ data }: SleepStagesChartProps) => {
  return (
    <ResponsiveSVG
      chartUpdate={sleepStagesUpdate}
      data={data}
      tooltip={<HoverTooltip className={"tooltip"} />}
    >
      <g className={"bars"} />
      <g className={"lines"} />
      <XAxisGroup className={"xAxis"} />
      <Tags className={"tags"} />
      <g className={"sideBars"}>
        <SideBar className={"left"} />
        <SideBar className={"right"} />
      </g>
      <YAxisGroup className={"yAxis"} />
    </ResponsiveSVG>
  );
};
